import { inject, Injector, Signal, TemplateRef } from '@angular/core';
import { InputModalComponent } from '../components/input-modal/input-modal.component';
import { ModalService } from '../modal.service';
import { Dismissed, ResolvableModalConfig } from '../types/modal-config';

export interface InputModalConfig {
  title?: string | Signal<string | null>;
  subtitle?: string | Signal<string | null>;
  content?: TemplateRef<any> | Signal<TemplateRef<any> | null>;
  contentContext?: object | Signal<object | null>;
  class?: string;
  dismiss?: boolean;
  textValue: string | Signal<string>;
  placeholder?: string | Signal<string>;
  multiline: boolean | Signal<boolean>;
  saveButtonText?: string | Signal<string>;
  dismissOnNavigation?: boolean;
}

async function input(
  modalService: ModalService,
  config: InputModalConfig,
  injector: Injector
): Promise<string | Dismissed> {
  const modalConfig: ResolvableModalConfig<InputModalComponent, string> = {
    component: InputModalComponent,
    dismiss: config.dismiss,
    title: config.title,
    subtitle: config.subtitle,
    template: config.content,
    templateContext: config.contentContext,
    data: {
      textValue: config.textValue,
      placeholder: config.placeholder,
      multiline: config.multiline,
      saveButtonText: config.saveButtonText,
    },
    class: config.class,
    injector: injector,
    dismissOnNavigation: config.dismissOnNavigation ?? true,
  };
  return await modalService.open(modalConfig);
}

export function inputFn(): (config: InputModalConfig) => Promise<string | Dismissed> {
  const modalService = inject(ModalService);
  const injector = inject(Injector);
  return (config) => input(modalService, config, injector);
}
